import { __assign } from "tslib";
import { createTheme } from '@fluentui/react';
export var defaultLightTheme = createTheme({
    palette: {
        // main colors
        themePrimary: '#185abd',
        themeLight: '#2e6ac5',
        themeLighter: '#6794d7',
        themeLighterAlt: '#aec6eb',
        themeSecondary: '#d2e0f4',
        themeDark: '#1651aa',
        themeDarker: '#13458f',
        themeDarkAlt: '#0e336a',
        // neutral colors
        neutralDark: '#252423',
        neutralPrimary: '#323130',
        neutralPrimaryAlt: '#605E5C',
        neutralSecondary: '#797775',
        neutralSecondaryAlt: '#8A8886',
        neutralTertiary: '#B3B0AD',
        neutralTertiaryAlt: '#BEBBB8',
        neutralQuaternary: '#C8C6C4',
        neutralQuaternaryAlt: '#D2D0CE',
        neutralLight: '#E1DFDD',
        neutralLighter: '#EDEBE9',
        neutralLighterAlt: '#F3F2F1',
        black: '#000000',
        white: '#FFFFFF',
    },
});
export var defaultDarkTheme = createTheme({
    palette: __assign(__assign({}, defaultLightTheme.palette), { 
        // neutral colors
        neutralDark: '#F3F2F1', neutralPrimary: '#D2D0CE', neutralPrimaryAlt: '#B3B0AD', neutralSecondary: '#979593', neutralSecondaryAlt: '#797775', neutralTertiary: '#605E5C', neutralTertiaryAlt: '#484644', neutralQuaternary: '#3B3A39', neutralQuaternaryAlt: '#292827', neutralLight: '#323130', neutralLighter: '#1B1A19', neutralLighterAlt: '#252423', black: '#FFFFFF', white: '#000000' }),
});
//# sourceMappingURL=DefaultThemes.js.map